import { TAppEnvironment } from './types-app-environment';

const AppEnvironment: TAppEnvironment = {
  env: import.meta.env.VITE_ENV_NAME,
  publicUrl: import.meta.env.VITE_PUBLIC_URL,
  selexpConParEndpoint: import.meta.env.VITE_SELEXP_CONPAR_ENDPOINT,
  selexpPerformanceEndpoint: import.meta.env.VITE_SELEXP_PERFORMANCE_ENDPOINT,
  selexpEarningsEndpoint: import.meta.env.VITE_SELEXP_EARNINGS_ENDPOINT,
  selexpComplianceEndpoint: import.meta.env.VITE_SELEXP_COMPLIANCE_ENDPOINT,
  selexpNotifiEndpoint: import.meta.env.VITE_SELEXP_NOTIFI_ENDPOINT,
  aadClientId: import.meta.env.VITE_AAD_CLIENT_ID,
  aadTenantAuthority: import.meta.env.VITE_AAD_TENANT_AUTHORITY,
  tokenAuthorithyGraph: import.meta.env.VITE_TOKEN_AUTHORITY_GRAPH,
  tokenAuthorithySelexp: import.meta.env.VITE_TOKEN_AUTHORITY_SELEXP,
  appInsightsConnectionString: import.meta.env.VITE_AI_CONNECTION_STRING,
  consoleLogging: import.meta.env.VITE_CONSOLE_LOGGING === 'true',
  msalConsoleLogging: import.meta.env.VITE_MSAL_CONSOLE_LOGGING === 'true',
  demoUserParticipationId: 999999,
  graphEndpoint: import.meta.env.VITE_GRAPH_ENDPOINT,
  graphDomain: import.meta.env.VITE_GRAPH_DOMAIN,
  ocvNsatSurvey: {
    surveyName: import.meta.env.VITE_OCV_NSAT_SURVEY_NAME,
    triggerName: import.meta.env.VITE_OCV_NSAT_SURVEY_TRIGGER,
  },
};

export default AppEnvironment;
